/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monsterplanlabel1m2Inputs */



/**
* | output |
* | --- |
* | "1 month" |
*
* @param {Monsterplanlabel1m2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const monsterplanlabel1m2 = /** @type {((inputs?: Monsterplanlabel1m2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monsterplanlabel1m2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("1 month")
	if (locale === "es") return /** @type {LocalizedString} */ ("1 mes")
	return /** @type {LocalizedString} */ ("1 месяц")
});
export { monsterplanlabel1m2 as "monsterPlanLabel1m" }